/**
 * Compatibility redirect for dead frontend path
 * /workspaces/:workspaceId/projects/:projectId → /projects/:projectId
 *
 * Historical notification deep links used this shape; it was never a
 * registered route and bounced through 404 → /home.
 */
import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";

import { useWorkspaceStore } from "@/state/workspace.store";

export default function LegacyWorkspaceProjectRedirect() {
  const { workspaceId, projectId } = useParams<{
    workspaceId: string;
    projectId: string;
  }>();
  const setActiveWorkspace = useWorkspaceStore((s) => s.setActiveWorkspace);

  useEffect(() => {
    console.warn(
      "[routing] legacy deep link /workspaces/:wsId/projects/:projectId — redirecting to /projects/:projectId",
      { workspaceId, projectId },
    );
    if (workspaceId) setActiveWorkspace(workspaceId);
  }, [workspaceId, projectId, setActiveWorkspace]);

  if (!projectId) {
    return <Navigate to="/workspaces" replace />;
  }

  // Client-side replace redirect only — not a duplicate project mount.
  return <Navigate to={`/projects/${projectId}`} replace />;
}
